module.exports = __webpack_public_path__ + "static/media/icon3.c1208785.png";